module.exports = __webpack_public_path__ + "img/torch.74d3fcb9.png";